import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CONSENT_KEY = 'wle-cookie-consent';
const CONSENT_LEVEL_KEY = 'wle-consent-level';

const loadAnalytics = () => {
  // Placeholder for Google Analytics or other tracking scripts
  // Implement when you add analytics
  console.log('Analytics consent granted - ready to load scripts');
};

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === 'true') {
      // Already consented, check if analytics should load
      if (localStorage.getItem(CONSENT_LEVEL_KEY) === 'all') {
        loadAnalytics();
      }
    } else {
      // Show banner after a short delay to not block initial render
      const timer = setTimeout(() => setShowBanner(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem(CONSENT_KEY, 'true');
    localStorage.setItem(CONSENT_LEVEL_KEY, 'all');
    loadAnalytics();
    setShowBanner(false);
  };

  const handleEssentialOnly = () => {
    localStorage.setItem(CONSENT_KEY, 'true');
    localStorage.setItem(CONSENT_LEVEL_KEY, 'essential');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-slate-900/95 backdrop-blur-sm border-t-2 border-wle-blue p-4 md:p-6 animate-fade-in">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <Cookie className="h-6 w-6 text-wle-blue flex-shrink-0 hidden md:block" />
          <div className="flex-1">
            <p className="text-sm text-gray-200">
              We use cookies to improve your browsing experience, analyze website traffic, and support essential site functionality. By clicking 'Accept All', you consent to our use of cookies.{' '}
              <Link to="/cookie-policy" className="text-wle-blue hover:underline">
                Learn more
              </Link>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
            <Button
              variant="outline"
              onClick={handleEssentialOnly}
              className="border-gray-500 text-gray-200 hover:bg-gray-800 hover:text-white"
            >
              Essential Only
            </Button>
            <Button
              onClick={handleAcceptAll}
              className="bg-wle-blue hover:bg-wle-blue/90 text-white"
            >
              Accept All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
